function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 20,
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M28.5303 19.4697C28.8232 19.7626 28.8232 20.2374 28.5303 20.5303L20.5303 28.5303C20.3839 28.6768 20.1919 28.75 20 28.75C19.8983 28.75 19.8013 28.7298 19.7129 28.6931C19.6245 28.6565 19.5416 28.6022 19.4697 28.5303L11.4697 20.5303C11.1768 20.2374 11.1768 19.7626 11.4697 19.4697C11.7626 19.1768 12.2374 19.1768 12.5303 19.4697L19.25 26.1893L19.25 12C19.25 11.5858 19.5858 11.25 20 11.25C20.4142 11.25 20.75 11.5858 20.75 12L20.75 26.1893L27.4697 19.4697C27.7626 19.1768 28.2374 19.1768 28.5303 19.4697Z",
  fill: "#111826"
});

function SvgRoundedDownArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedDownArrow);
export default __webpack_public_path__ + "static/media/RoundedDownArrow.104c792cbf4b2300a65f5c5a06c43411.svg";
export { ForwardRef as ReactComponent };